(() => {
  if (customElements.get('cravot-video-gallery')) return;

  class CravotVideoGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.track = this.querySelector('[data-gallery-track]');
      this.previousButton = this.querySelector('[data-gallery-previous]');
      this.nextButton = this.querySelector('[data-gallery-next]');
      this.controls = this.querySelector('[data-gallery-controls]');
      this.dots = this.querySelector('[data-gallery-dots]');

      this.previousButton?.addEventListener('click', () => this.scrollGallery(-1));
      this.nextButton?.addEventListener('click', () => this.scrollGallery(1));
      this.track?.addEventListener('scroll', () => this.updateControls(), { passive: true });
      window.addEventListener('resize', () => this.updateControls(), { passive: true });

      this.updateControls();
    }

    scrollGallery(direction) {
      const card = this.track?.querySelector('.cravot-video-card');
      if (!this.track || !card) return;

      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }

    updateControls() {
      if (!this.track) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const card = this.track.querySelector('.cravot-video-card');
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
      const pageCount = maxScroll > 2 ? Math.max(2, Math.ceil(maxScroll / step) + 1) : 1;
      const activePage = maxScroll > 2 ? Math.min(pageCount - 1, Math.round(this.track.scrollLeft / step)) : 0;

      if (this.controls) this.controls.hidden = pageCount <= 1;
      if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 2;
      if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 2;

      if (this.dots && this.dots.childElementCount !== pageCount) {
        this.dots.replaceChildren();
        for (let index = 0; index < pageCount; index += 1) {
          const dot = document.createElement('span');
          dot.className = 'cravot-video-gallery__dot';
          this.dots.appendChild(dot);
        }
      }

      this.dots?.querySelectorAll('.cravot-video-gallery__dot').forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activePage);
      });
    }
  }

  customElements.define('cravot-video-gallery', CravotVideoGallery);
})();
